import React, { useState, useEffect, useRef } from 'react';
import { Icons } from './icons';

export type HeaderUserMenuItem = {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  href?: string;
  external?: boolean;
};

export function HeaderUserMenu({
  userName,
  roleLabel,
  items,
  onLogout,
}: {
  userName: string;
  roleLabel?: string;
  items?: HeaderUserMenuItem[];
  onLogout: () => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(function () {
    const handler = function (e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return function () {
      document.removeEventListener('mousedown', handler);
    };
  }, []);

  return (
    <div
      className={'header-user-menu' + (open ? ' open' : '')}
      ref={ref}
      onClick={function () {
        setOpen(function (v) {
          return !v;
        });
      }}
    >
      <Icons.User />
      <span className={'header-user-name'}>{userName}</span>
      <Icons.ChevronDown w={12} h={12} />
      {open && (
        <div
          className={'header-user-dropdown'}
          onClick={function (e) {
            e.stopPropagation();
          }}
        >
          <div className={'header-user-dropdown-head'}>
            {roleLabel ? <span className={'tag tag-purple'}>{roleLabel}</span> : null}
            <div className={'header-user-dropdown-meta'}>
              {userName} · {new Date().toLocaleDateString()}
            </div>
          </div>
          {(items || []).map(function (item) {
            if (item.href) {
              return (
                <a
                  key={item.key}
                  className={'header-user-dropdown-item'}
                  href={item.href}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noopener noreferrer' : undefined}
                  onClick={function () {
                    setOpen(false);
                  }}
                >
                  {item.icon}
                  {item.label}
                </a>
              );
            }
            return (
              <button
                key={item.key}
                type={'button'}
                className={'header-user-dropdown-item'}
                onClick={function () {
                  setOpen(false);
                  item.onClick?.();
                }}
              >
                {item.icon}
                {item.label}
              </button>
            );
          })}
          <button
            type={'button'}
            className={'header-user-dropdown-item danger'}
            onClick={function () {
              setOpen(false);
              onLogout();
            }}
          >
            <Icons.LogOut />
            退出登录
          </button>
        </div>
      )}
    </div>
  );
}
